import React, { useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { ChevronDown, ChevronUp } from "src/Icons";

interface SelectMenuItemProp {
  selected: boolean;
  title: string;
  value: string;
  label: string;
}

const SelectMenuItem = ({
  value,
  selected,
  title,
  label,
  ...rest
}: SelectMenuItemProp) => {
  return (
    <MenuItem
      value={title}
      disableRipple
      {...rest}
      sx={{
        // borderBottomRadius: '2px',
        "&.MuiMenuItem-root": {
          minWidth: 120,
          fontSize: "14px",
          height: "42px",
          margin: "0",
          border: "none",
          backgroundColor: selected ? "#BF295C" : "transparent",
          color: selected ? "white" : "#1F1F1F",
          '&:hover:not([aria-selected="true"])': {
            backgroundColor: "#FAFAFA",
            color: "#BF295C",

            "& .Mui-checked": {
              backgroundColor: "transparent",
            },
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: "transparent",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {title}
        </Typography>
      </Box>
    </MenuItem>
  );
};

interface DefaultSingleSelectorWithoutBodyProps {
  label: string;
  value?: number;
  sx?: any;
  onChange: (newValue: any) => void;
  valueToSelect: any[];
}

export const DefaultSingleSelectorWithoutBody = ({
  label,
  value,
  valueToSelect,
  onChange,
  sx,
}: DefaultSingleSelectorWithoutBodyProps) => {
  const [isSectionOpen, setIsSectionOpen] = useState<boolean>(false);

  const handleChange = ({ target: { value } }: any) => {
    onChange?.(value);
  };

  const renderValue = (value: string) => {
    const withOutValue = "Not selected";

    const { label } = valueToSelect.find(({ id }: any) => id === value) || {};

    return value === withOutValue ? (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "16px",
        }}
      >
        <Typography
          sx={{
            color: "#828282",
            fontSize: "16px",
          }}
        >
          {withOutValue}
        </Typography>
      </Box>
    ) : (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "16px",
        }}
      >
        <Typography
          sx={{
            color: "#1F1F1F",
            fontSize: "14px",
          }}
        >
          {label}
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: "186px",
        marginLeft: "16px",
        marginTop: "24px",
        ...sx
      }}
    >
      <FormControl fullWidth>
        <InputLabel id={`select-${label}-label`}>{label}</InputLabel>
        <Select
          labelId={`select-${label}-label`}
          id={`select-${label}`}
          //@ts-ignore
          value={(!value || +value === 0) ? "Not selected" : value}
          label={label}
          onOpen={() => setIsSectionOpen(true)}
          onClose={() => setIsSectionOpen(false)}
          onChange={handleChange}
          renderValue={renderValue}
          IconComponent={() => (
            <>
              {isSectionOpen ? (
                <ChevronUp fontSize="inherit" />
              ) : (
                <ChevronDown fontSize="inherit" />
              )}
            </>
          )}
          sx={{
            borderRadius: "8px",
            color: "#1F1F1F",
            fontWeight: "500",
            height: "48px",

            "& .MuiSvgIcon-root": {
              marginRight: "14px",
              color: isSectionOpen ? "#BF295C" : "#676767",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                marginTop: "4px",
                boxShadow:
                  "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",

                "& .MuiList-root": {
                  padding: 0,
                },

                "& .MuiMenuItem-root": {
                  borderRadius: "6px",
                  marginTop: 8,
                  minWidth: 120,
                  color: "#363636",
                  fontSize: "14px",
                  height: "38px",
                  margin: "0",
                  "&:hover": {
                    backgroundColor: "#BF295C",
                    color: "white",
                  },
                  "&.Mui-selected, &.Mui-selected:hover": {
                    backgroundColor: "transparent",
                    color: "#BF295C",
                  },
                },
              },
            },
          }}
        >
          {valueToSelect.map(
            ({ id, label }: any) =>
              value !== id && (
                <SelectMenuItem
                  key={id}
                  label={id}
                  value={id}
                  selected={value === id}
                  title={label}
                />
              )
          )}
        </Select>
      </FormControl>
    </Box>
  );
};
